import(/* webpackMode: "eager" */ "/root/job_portal/frontend-v5/src/app/(marketing)/error.tsx");
